import PageDataFeed from "./page-data-feed";

const FORMATTERS: Record<string, Intl.NumberFormat> = {};

const buildFormater = (currency: string): Intl.NumberFormat => new Intl.NumberFormat(undefined, {
	// style: 'currency',
	// currency: currency
	minimumFractionDigits: 2
});

const getFormatter = (currency: string): Intl.NumberFormat => {
	if (!FORMATTERS[currency])
		FORMATTERS[currency] = buildFormater(currency)
	return FORMATTERS[currency];
}

export default function formatCurrency(
	amount: number, 
	currency: string = (PageDataFeed as any).data.currency
): string {
	return getFormatter(currency).format(amount)
}